import axios from 'axios';
import appLogger from '../../utils/logging';

const eventsservice = axios.create({
  baseURL: `${process.env.REACT_APP_AUTH_SERVICE_BASE_URL}public/events/`,
});

const questionnaireservice = axios.create({
  baseURL: `${process.env.REACT_APP_QUESTIONNAIRE_SERVICE_BASE_URL}/api/v1/public`,
});

const eventsservicegetquestionnaire = axios.create({
  baseURL: `${process.env.REACT_APP_AUTH_SERVICE_BASE_URL}api/v1/public`,
});

const g2wbrokergetquestionnaire = axios.create({
  baseURL: `${process.env.REACT_APP_G2W_BROKER_BASE_URL}/api/v1/public`,
});

const paymentService = axios.create({
  baseURL: `${process.env.REACT_APP_PAYMENT_SERVICE_URL}`,
});

const couponService = axios.create({
  baseURL: `${process.env.REACT_APP_COUPON_SERVICE_URL}`,
});

const getEventDetails = (id: string) =>
  eventsservice.get(`${id}`).catch((err) => {
    return err;
  });

const sendRegistrationDetails = (eventKey: any, body: any) => {
  return eventsservice.post(`${eventKey}/registrations`, body);
};

const getUserDetails = (body: any) => {
  return eventsservice.get(`registrations/${body.eventRegistrationId}`);
};

const getConferenceRegistration = (body: any) => {
  return eventsservice.post(
    `registrations/${body.eventRegistrationId}/conferences/${body.conferenceKey}`,
  );
};

const cancelRegisteredEvent = (eventRegistrationId: string) =>
  eventsservice.delete(`registrations/${eventRegistrationId}`);

const getQuestionnaire = async (
  questionnaireKey: string,
  locale: string,
  proxyQuestionareCalls: string,
) => {
  const endpoint = `/questionnaires/${questionnaireKey}`;
  const options = {
    headers: { 'Accept-Language': locale },
  };
  let service = questionnaireservice;
  try {
    switch (proxyQuestionareCalls) {
      case 'DIRECT':
        service = questionnaireservice;
        break;
      case 'BROKER':
        service = g2wbrokergetquestionnaire;
        break;
      case 'EVENTSERVICE':
        service = eventsservicegetquestionnaire;
        break;
      default:
        appLogger.warn(
          'No valid proxy set for get questionnaire calls, using default service:questionnaireservice',
        );
        service = questionnaireservice;
    }

    const response = await service.get(endpoint, options);
    return response;
  } catch (error: any) {
    const fullURL = `${service.defaults.baseURL}${endpoint}`;
    appLogger.error('Error on API Request:', 'url =', fullURL, 'error =', error);
    throw error;
  }
};

const getPaymentDetails = (eventId: string) => {
  return paymentService.get(`/prices/products/g2w/referenceKeys/${eventId}`);
};

const checkCouponExists = (eventId: string) => {
  return couponService.get(`/associations/products/g2w/references/${eventId}/exists`);
};

const validateCoupon = (payload: any) => {
  const body = { alias: payload.promoCode };
  return couponService.post(`/coupons/products/g2w/references/${payload.eventKey}/validate`, body);
};

const API = {
  getEventDetails,
  sendRegistrationDetails,
  getUserDetails,
  getConferenceRegistration,
  cancelRegisteredEvent,
  getQuestionnaire,
  getPaymentDetails,
  checkCouponExists,
  validateCoupon,
};

export default API;
